import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {AgGridModule} from 'ag-grid-angular';
import {MachinesListComponent} from './machine-documentation/machines-list/machines-list.component';

@NgModule({
  imports: [AgGridModule, SharedModule],
  declarations: [MachinesListComponent],
  exports: [MachinesListComponent, SharedModule]
})
export class TexbotSharedModule {}
